import { startOfMonth, setDate, getDaysInMonth, lastDayOfMonth, } from 'date-fns';
export const useHalfToDate = (halfDate, isEndDate = false) => {
    if (!halfDate || typeof halfDate !== 'string') {
        return null;
    }
    const [yearStr, monthStr, halfStr] = halfDate.split('-');
    const year = Number(yearStr);
    const month = Number(monthStr);
    const half = Number(halfStr);
    if (Number.isNaN(year) ||
        Number.isNaN(month) ||
        Number.isNaN(half) ||
        month < 1 ||
        month > 12 ||
        (half !== 1 && half !== 2)) {
        return null;
    }
    const baseDate = new Date(year, month - 1);
    const daysInMonth = getDaysInMonth(baseDate);
    const midDay = daysInMonth <= 29 ? 14 : 15;
    if (isEndDate) {
        return half === 1 ? setDate(baseDate, midDay) : lastDayOfMonth(baseDate);
    }
    return half === 1 ? startOfMonth(baseDate) : setDate(baseDate, midDay);
};
